import styled from '@emotion/styled';

export const DropdownWrapper = styled.div`
  width: 160px;
`;
export const TopHeaderToggles = styled.div`
  display: flex;
  flex-flow: column;
  gap: 36px;
`;
